import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

declare var Stripe: any;
declare var window: any;

@Component({
  selector: 'app-stripe-payments',
  templateUrl: './stripe-payments.component.html',
  styleUrls: ['./stripe-payments.component.css']
})


export class StripePaymentsComponent implements OnInit {

  @Input() clientSecret: string;
  @Input() intentId: string;
  @Input() returnUrl: string;
  @Input() paymentInitiated: Subject<boolean>;

  paymentFailed: boolean;
  paymentFailedMessage: string;
  stripe: any;
  elements: any;

  constructor() { }

  ngOnInit() {
   
    this.stripe = Stripe('pk_test_51N9UEkFpraaQp5PrCYAaa7h4dDxMyG7xkDcPJj0VnkVUksHPyxoiUoOyZlQvOAzHEN8eyKU6SXHKo0c8xd7ND7yq00CdN9KWXi');
    const options = {
      clientSecret: this.clientSecret,
    };
    
    // Set up Stripe.js and Elements using the SetupIntent's client secret
    this.elements = this.stripe.elements(options);
    this.paymentFailed = false;
    
    // Create and mount the Payment Element
    const paymentElement = this.elements.create('payment');
    paymentElement.mount('#payment-element');

    const addressOptions = { mode: 'billing' };
    const addressElements = this.stripe.elements({ clienSecret: this.clientSecret });
    const addressElement = addressElements.create('address', addressOptions);
    addressElement.mount('#address-element');

    const eIntent = encodeURIComponent(this.intentId);
    const eUrl = encodeURIComponent(this.returnUrl);

    this.paymentInitiated.subscribe( async () => {
      this.paymentFailed = false;
      const {error} = await this.stripe.confirmSetup({
        //`Elements` instance that was used to create the Payment Element
        elements: this.elements,
        confirmParams: {
          return_url: `${window.location.origin}/#/payment-confirmation/${eIntent}/${eUrl}`,
        }
      });

      if (error) {
        this.paymentFailed = true;
        this.paymentFailedMessage = error.message;
      }
    })
  }
}
